import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Image, Item, Popup as SemanticPopup, Table} from "semantic-ui-react";
import {Eingang, Wohnung} from "../../../../models/gebaeude";
import {Icon} from "../../../../core/components/icon/icon";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";
import {withStore} from "../../../../core/stores/abstract-app-store";

export interface WohnungTableProps {
    data: Wohnung[];
    eingang: Eingang;
    handleHighlightClick: (e: React.MouseEvent | undefined, eingang: Eingang | null) => void;
    title?: string;
    store?: MapViewerStore; // this is injected by withStore
}
interface SortAction {
    type: string;
    column: string;
}
@observer
class WohnungTableBase extends Component<WohnungTableProps, any> {
    watchHandles: any[] = [];
    constructor(props: WohnungTableProps) {
        super(props);
        this.state = {
            column: "nummer",
            data: _.orderBy(this.props.data, ["nummer"], ["asc"]),
            direction: "ascending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    handleHighlightClick(e: React.MouseEvent): void {
        const { store, eingang } = this.props;
        if (eingang.edid === store?.oStore.edid){
            this.props.handleHighlightClick(e, null);
            store?.oStore.setEdid(undefined);
        } else {
            this.props.handleHighlightClick(e, eingang);
            store?.oStore.setEdid(eingang.edid);
        }
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { column, data, direction } = this.state;
        const { eingang, store } = this.props;
        const edid = store?.oStore?.edid;
        const displayPhysNr = false;
        if (data === null){
            return null;
        }
        let title: string;
        if (this.props.title) {
            title = this.props.title;
        } else {
            title = "";
        }
        if (data.length === 0) {
            return (
                <Item className={"geo-wohnungen" + ((eingang.edid === edid) ? " highlighted" : "")}><Item.Content>
                    <Item.Header as="h3" onClick={(event: React.MouseEvent) => this.handleHighlightClick(event)}>
                        <Image src={store?.mapViewerConfig.pointerSymbols?.eingang.url}
                            height="24" verticalAlign="middle" />{title}</Item.Header>
                    <p>keine</p>
                </Item.Content></Item>);
        }
        return (
            <Item className={"geo-wohnungen" + ((eingang.edid === edid) ? " highlighted" : "")}><Item.Content>
                <Item.Header as="h3" onClick={(event: React.MouseEvent) => this.handleHighlightClick(event)}>
                    <Image src={store?.mapViewerConfig.pointerSymbols?.eingang.url}
                        height="24" verticalAlign="middle" />{title}</Item.Header>
                <Table basic="very" sortable={(data.length > 1)} compact className={"wohnung"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine
                                sorted={column === "nummer" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "nummer" })}>
                                EGID / EWID</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "adminNr" ? direction : null}
                                className={"number"}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "adminNr" })}>
                                <SemanticPopup
                                    wide
                                    content={(<div><strong>Administrative Wohnungsnummer</strong><p>Die administrative
                                        Wohnungsnummer wird von der kommunalen oder kantonalen Behörde vergeben und
                                        kennzeichnet eine Wohnung innerhalb eines Gebäudes und bleibt bei Mieterwechsel
                                        u.dgl. bestehen.</p>
                                    <p>Es kann sich um die Wohnungsnummer eines industriellen Werkes oder eine
                                            andere systematisch angewendete Nummerierung der Wohnungen handeln, welche
                                            von der Gemeinde zur offiziellen Wohnungsnummer erklärt wurde.</p>
                                    <p>Wenn in einem Gebäude die administrativen Wohnungsnummern als
                                            Briefkastennummern, Klingelnummern, Türnummern oder dergleichen angebracht
                                            sind, stimmen diese Angaben mit der physischen Wohnungsnummer überein.
                                        In allen anderen Fällen ist die administrative Wohnungsnummer nur einem
                                        eingeschränkten Kreis von Verwaltungsstellen und Personen bekannt.
                                    </p></div>)}
                                    trigger={<span>Admin Nr. <Icon name={"information"} /></span>} /></Table.HeaderCell>
                            {(displayPhysNr? <Table.HeaderCell singleLine
                                sorted={column === "physNr" ? direction : null}
                                className={"number"}
                                onClick={() => this.sort({
                                    type: "CHANGE_SORT",
                                    column: "physNr"
                                })}>
                                <SemanticPopup
                                    wide
                                    content={(<div><strong>Physische Wohnungsnummer</strong>
                                        <p>In grösseren Überbauungen sind einzelne Wohnungen zur besseren Orientierung
                                        häufig an Briefkästen, Türen usw. nummeriert.</p></div>)}
                                    trigger={<span>Phys. Nr. <Icon
                                        name={"information"}/></span>}/></Table.HeaderCell>: null
                            )}
                            <Table.HeaderCell singleLine
                                sorted={column === "stockwerk" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "stockwerk" })}>
                                Stockwerk</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "lageStockwerk" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "lageStockwerk" })}>
                                Lage</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "status" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "status" })}>
                            Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data.map((wohnung: Wohnung) => (
                            <Table.Row key={wohnung.itemId}>
                                <Table.Cell>{wohnung.nummer}</Table.Cell>
                                <Table.Cell>{(wohnung.adminNr? wohnung.adminNr: "-")}</Table.Cell>
                                {(displayPhysNr? <Table.Cell>{(wohnung.physNr? wohnung.physNr: "-")}</Table.Cell>: null)}
                                <Table.Cell>{(wohnung.stockwerk? wohnung.stockwerk: "-")}</Table.Cell>
                                <Table.Cell>{(wohnung.lageStockwerk? wohnung.lageStockwerk: "-")}</Table.Cell>
                                <Table.Cell singleLine className={"status"}>{wohnung.status}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </Item.Content></Item>
        );
    }
}

export const WohnungTable = withStore(WohnungTableBase);
